import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from './css';
import DiscountCalculatorDetails from './discountCalculatorDetails';

const DiscountCalculator = ({ discountData, onSave, fetchData }) => {
  const [
    isDiscountCalculatorOrderVisible,
    setIsDiscountCalculatorOrderVisible
  ] = useState(false);

  const showPopUp = () => {
    setIsDiscountCalculatorOrderVisible(true);
  };

  const hidePopUp = () => {
    setIsDiscountCalculatorOrderVisible(false);
  };

  const onStatusUpdateSuccess = () => {
    window.location.reload();
    hidePopUp();
  };

  const isViewOnly = ['Approved', 'Rejected'].includes(discountData.status);

  return (
    <>
      <Button onClick={() => showPopUp()}>
        {isViewOnly ? 'View' : 'Discount Calculator'}
      </Button>
      {isDiscountCalculatorOrderVisible && (
        <DiscountCalculatorDetails
          open={isDiscountCalculatorOrderVisible}
          setOpen={hidePopUp}
          onStatusUpdateSuccess={onStatusUpdateSuccess}
          discountData={discountData}
          isViewOnly={isViewOnly}
        />
      )}
    </>
  );
};

DiscountCalculator.propTypes = {
  discountData: PropTypes.shape({
    orderId: PropTypes.string,
    id: PropTypes.number,
    status: PropTypes.string,
    productSelection: PropTypes.arrayOf(PropTypes.string)
  }).isRequired
};

export default DiscountCalculator;
